module.exports = {"id":"23823","name":"Andreas Johansson","rating":"73","photo":"./data/images/photos/3/23823.png","club":{"name":"IFK Norrköping","logo":"./data/images/clubs/IFKNorrkoping.png"},"positions":["DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AndreasJohansson0.json
// module id = 377
// module chunks = 0